import { Select } from 'antd'
import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/shared/api/queryKeys'
import { fetchDeviceTypes } from './profileApi'

interface DeviceTypeSelectProps {
  value?: string | null
  onChange?: (value: string | undefined) => void
  /** Filtrda o'chirilganlari ham kerak — eski abonentlarda turibdi */
  includeInactive?: boolean
  /** Ro'yxatda yo'q (o'chirilgan) joriy qiymat nomi */
  currentName?: string | null
  placeholder?: string
  allowClear?: boolean
}

export function DeviceTypeSelect({
  value,
  onChange,
  includeInactive = false,
  currentName,
  placeholder,
  allowClear,
}: DeviceTypeSelectProps) {
  const types = useQuery({
    queryKey: queryKeys.subscribers.deviceTypes(includeInactive),
    queryFn: () => fetchDeviceTypes(includeInactive),
    staleTime: 60_000,
  })
  const options = (types.data ?? []).map((d) => ({ value: d.id, label: d.name }))
  if (value && !options.some((o) => o.value === value)) {
    options.push({ value, label: currentName ?? '—' })
  }
  return (
    <Select
      value={value ?? undefined}
      onChange={onChange}
      loading={types.isPending}
      options={options}
      showSearch
      optionFilterProp="label"
      placeholder={placeholder}
      allowClear={allowClear}
      style={{ width: '100%' }}
    />
  )
}
